module.exports = __webpack_public_path__ + "static/media/2020.10_02.jpg";